// extracted by mini-css-extract-plugin
export default {"container":"NoContent_container__WBRsm","icon":"NoContent_icon__pbRvg"};